module.exports = __webpack_public_path__ + "static/media/img3-1.a760319b.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/maiz/soilcheck/mo/img3-1.png
// module id = 1729
// module chunks = 3